import { AttrMap } from "./indexed-mesh";
import { BufferGeometry, Float32BufferAttribute, Uint16BufferAttribute, Uint32BufferAttribute } from "three";
import { IndexedMeshWriter } from "./indexed-mesh-writer";


/**
 * Converts the IndexedMesh instance to a THREE.BufferGeometry instance,
 * sharing the typed array data between them.
 */
export const generateBufferGeometry = <T extends AttrMap>(writer: IndexedMeshWriter<T>) =>
{
    const
        geo = new BufferGeometry(),
        mesh = writer.make();

    let start = 0, end = 0;

    end += mesh.index.size * mesh.index.count;
    const idx = end < 65536
        ? new Uint16BufferAttribute(mesh.index.data, 1)
        : new Uint32BufferAttribute(mesh.index.data, 1);
    idx.name = 'index';
    // Note that index is special, it's not held in the attributes property
    // of the THREE.BufferGeometry
    geo.index = idx;

    geo.name = writer.constructor.name;

    start = end;
    end += mesh.position.size * mesh.position.count;
    const pos = new Float32BufferAttribute(mesh.position.data, 3);
    pos.name = 'position';
    geo.setAttribute('position', pos);

    for(const name of Object.keys(mesh.attrs)) {
        const attr = mesh.attrs[name];
        start = end;
        end += attr.size * attr.count;
        const buf = new Float32BufferAttribute(attr.data, attr.size);
        buf.name = name;
        geo.setAttribute(name, buf);
    }

    return geo;
}
